<template>
  <div id="content-wrap">
    <div class="box box-widget widget-user-2">
      <div @click="goHome()" class="widget-user-header" style="background-color: #367fa9; cursor: pointer;">
        <img src="../../static/img/logo-small.png" style="height: 80px; cursor: pointer; padding-left: 1%;" alt="Printer Counters" />
        <h4 class="widget-user-desc" style="margin-left: 5%; cursor: pointer;">Printer Counters Monitoring</h4>
        <h5 class="widget-user-desc" style="margin-left: 5%; cursor: pointer;">Ver. {{$root.version}}</h5>
      </div>
      <div id="info">
        <div class="container">
          <div class="row">
            <div class="col-md-12 col-sm-12" style="margin-bottom: 60px;">
              <h1 style="color:#ff0000; font-size:34px; text-align: center;">{{$root.Announcement.Title}}</h1>
              <h2 style="color:#58585a; text-align: center; margin-left: 100px; margin-right: 100px;">
                <i>{{$root.Announcement.Info}}</i>
              </h2>
              <h3 style="color:#58585a; text-align: center;"><i>Please retry later !!</i></h3>
            </div>
          </div>
        </div>
      </div>
      <contact></contact>
      <footerBox></footerBox>
    </div>
  </div>
</template>
<script>
  import navbar from '../components/Home/navbar'
  import info from '../components/Home/info'
  import gallery from '../components/Home/gallery'
  import slides from '../components/Home/slides'
  import services from '../components/Home/services'
  import divider from '../components/Home/divider'
  // import price from '../components/Home/price'
  import projects from '../components/Home/projects'
  import contact from '../components/Home/contact'
  import footerBox from '../components/Home/footer'
  // import chromecastImages from '../lib/chromecast.json'
  export default {
    name: 'announcement',
    components: { navbar, info, slides, gallery, services, divider, projects, contact, footerBox },
    data () {
      return {
        activeMenu: '',
        boolTop: true,
        msg: '',
        randomImages: []
      }
    },
    created () {
    },
    mounted () {
    },
    updated () {
    },
    computed: {
    },
    methods: {
      goHome () {
        if (!this.$root.hasAnnouncement) {
          console.log('goHome')
          this.$root.goto('Home')
          location.reload(true)
        }
      }
    }
  }
</script>
<style>
  .spacer {
    width: 100%;
    height: 120px;
  }

  div.vue-friendly-iframe {
    width: 100%;
    height: 100%;
  }

    div.vue-friendly-iframe > iframe {
      width: 100%;
      height: 100%;
    }
</style>



// WEBPACK FOOTER //
// Announcement.vue?5e581f4a